import React from 'react';
import classnames from 'classnames';

import InputLabel from './InputLabel';

interface Props {
  name: string;
  type?: string;
  label?: string;
  isMandatory?: boolean;
  multiline?: boolean;
  error?: React.ReactNode;
  value?: string;
  placeholder?: string;
  readOnly?: boolean;
  handleChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  handleBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  containerClass?: string;
  disabled?: boolean;
}

const FormGroup: React.FC<Props> = (props) => {
  const {
    name,
    type,
    label,
    isMandatory,
    multiline,
    error,
    value,
    placeholder,
    readOnly,
    handleChange,
    handleBlur,
    containerClass,
    disabled,
  } = props;

  const inputProps = {
    className: classnames('form-elem', { 'bg-grey': readOnly, 'border-red': error }),
    name,
    readOnly,
    value: value || '',
    id: `${label || ''}-inputfield`,
    disabled,
    placeholder,
    onChange: handleChange,
    onBlur: handleBlur,
  };

  return (
    <div
      className={classnames('form-group', { [containerClass || '']: containerClass })}
      key={`${label || ''}-txtinput`}
    >
      {label && InputLabel(label, isMandatory)}

      {multiline ? <textarea {...inputProps} /> : <input type={type || 'text'} {...inputProps} />}
      {error && <span className="error-block">{error}</span>}
    </div>
  );
};

export default FormGroup;
